module.exports = __webpack_public_path__ + "static/media/img15.735a3cb3.jpg";